import axios from 'axios';

// Client senza l'interceptor dell'alert globale: lo usano le chiamate secondarie dello
// Smart multi-store, il cui errore non deve aprire il popup che blocca la prenotazione.
// Gli errori arrivano a React Query (isError) e il centro risulta non disponibile.
// Timeout breve: un centro lento non deve restare a lungo "in caricamento".
const silentClient = axios.create({
  baseURL: import.meta.env.VITE_NX_PUBLIC_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'text/plain',
  },
  timeout: 10000,
});

export { silentClient };
